export const BASE_URL = `${process.env.REACT_APP_BASE_URL}`;
export const SEEDFLEX_BASE_URL = `${process.env.REACT_APP_BASE_URL_SEEDFLEX}`;
export const SEEDFLEX_GOOGLE_SITEKEY = `${process.env.REACT_APP_GOOGLE_SITEKEY}`;
export const BOOST_ID = process.env.REACT_APP_BOOST_ID
  ? process.env.REACT_APP_BOOST_ID.split(',').map((id) => id.trim())
  : [];
export const PAYLATER_ID = process.env.REACT_APP_PAYLATER_ID
  ? process.env.REACT_APP_PAYLATER_ID.split(',').map((id) => id.trim())
  : [];
export const BANKSTATMENT = process.env.REACT_APP_BS_PARTNER
  ? process.env.REACT_APP_BS_PARTNER.split(',').map((id) => id.trim())
  : [];
export const ADD_POCKET_URL = `${process.env.REACT_APP_ADD_POCKET}`;
export const NODE_ENV = `${process.env.REACT_APP_NODE_ENV}`;
export const OTP_CHANNEL = `${process.env.REACT_APP_OTP_CHANNEL}`;
export const PAYROLL_ID = process.env.REACT_APP_PAYROLL_ID
  ? process.env.REACT_APP_PAYROLL_ID.split(',').map((id) => id.trim())
  : [];
// Iframe loading timeout in milliseconds (fallback 10000ms = 10 seconds)
export const IFRAME_LOADING_TIMEOUT_MS =
  Number(process.env.REACT_APP_IFRAME_LOADING_TIMEOUT_MS) || 10000;
export const PAYE_ID = process.env.REACT_APP_PAYE_ID
  ? process.env.REACT_APP_PAYE_ID.split(',').map((id) => id.trim())
  : [];
export const IDLE_TIME = `${process.env.REACT_APP_IDLE_TIME}`;
export const INDRIVE_ID = process.env.REACT_APP_INDRIVE_ID
  ? process.env.REACT_APP_INDRIVE_ID.split(',').map((id) => id.trim())
  : [];
export const JAIDEE_ID = process.env.REACT_APP_JAIDEE_ID
  ? process.env.REACT_APP_JAIDEE_ID.split(',').map((id) => id.trim())
  : [];
export const POSTHOG_TOKEN = `${process.env.REACT_APP_POSTHOG_PROJECT_TOKEN}`;
export const POSTHOG_HOST = `${process.env.REACT_APP_POSTHOG_HOST}`;
export const DASHBOARD_POLLING =
  Number(process.env.REACT_APP_DASHBOARD_POLLING) || 10000;
export const PROMPT_BS_UPLOAD_PARTNERIDS = process.env
  .REACT_APP_PROMPT_BS_UPLOAD_PARTNERIDS
  ? process.env.REACT_APP_PROMPT_BS_UPLOAD_PARTNERIDS.split(',').map((id) =>
      id.trim()
    )
  : [];
